module.exports = __webpack_public_path__ + "static/media/backward.f9c19128.svg";